export const mainRoutes = {
	home: '/home',
	reports: '/reports',
	testExplorer: '/test-explorer',
	activities: '/activities',
	assignments: '/assignments',
	studentManager: '/student-manager',
	parentConferencer: '/parent-conferencer',
} as const;
